export class CourseResponse {
    courseId: number;
    courseDescription: string;
    cycleId: string;
    schoolId: string;
    isEGDC: string;
}